// Mapuje datę na sezon i ustawia atrybut data-season na <html>.
// Czytany przez tokens.css → fenologiczne tinty tła.
//
// Półkula północna, podział meteorologiczny (PL):
//   wiosna: marzec–maj     (3,4,5)
//   lato:   czerwiec–sierpień (6,7,8)
//   jesień: wrzesień–listopad (9,10,11)
//   zima:   grudzień–luty   (12,1,2)

import { useEffect } from 'react';

export function getSeason(date = new Date()) {
  const m = date.getMonth() + 1;
  if (m >= 3 && m <= 5)  return 'spring';
  if (m >= 6 && m <= 8)  return 'summer';
  if (m >= 9 && m <= 11) return 'autumn';
  return 'winter';
}

export function applySeasonAttribute(date) {
  if (typeof document === 'undefined') return;
  const season = getSeason(date);
  document.documentElement.setAttribute('data-season', season);
}

// Hook do użycia w Layout / RedesignRoot.
// Aktualizuje przy mount i raz na godzinę (na wypadek przekroczenia północy / 1.dnia miesiąca).
export function useSeason() {
  useEffect(() => {
    applySeasonAttribute();
    const id = setInterval(applySeasonAttribute, 60 * 60 * 1000);
    return () => clearInterval(id);
  }, []);
}
